import styled from "styled-components"
import Breakpoints from "../shared/breakpoints"
import { T } from "../shared/typography.styles"
import Link from "../shared/smart-link"

export const BannerContainer = styled.div`
  padding: 32px 0;
  background-color: var(--tricorn-black);
  @media (min-width: ${Breakpoints.md}) {
    padding: 24px 0;
    ${T.md.h2.semiBold}
  }
  @media (min-width: ${Breakpoints.lg}) {
    padding: 48px 0;
    ${T.lg.h1.regular}
  }
`

export const BannerTitle = styled.h2`
  ${T.sm.h2.semiBold}

  text-align: center;
  color: var(--dark-mode-body-grey);

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.h2.semiBold}
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h1.regular}
  }
`

export const SectionContainer = styled.div`
  padding: 32px 0;

  @media (min-width: ${Breakpoints.md}) {
    padding: 48px 0;
  }
  @media (min-width: ${Breakpoints.lg}) {
    padding: 64px 0;
  }
`

export const PositionCardContainer = styled.div`
  grid-column: 1 / -1;
  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
  }
`

export const PositionCardWrapper = styled(Link)`
  display: block;
  padding: 16px;

  &,
  :visited,
  :link,
  :active {
    text-decoration: none;
  }

  :not(:first-child) {
    margin-top: 16px;
  }
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.07);

  @media (min-width: ${Breakpoints.md}) {
    padding: 16px 32px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`

export const PositionCardTitle = styled.h3`
  ${T.sm.h3.regular}

  text-align: center;
  color: var(--slate);

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.h3.bold}
  }
  @media (min-width: ${Breakpoints.lg}) {
    text-align: left;
    ${T.lg.h3.semiBold}
    font-size: 24px;
  }
`

export const PositionCardRequirements = styled.ul`
  ${T.sm.body.regular}
  font-size: 14px;
  display: flex;
  align-items: baseline;
  justify-content: center;
  color: var(--body-text-grey);
  margin: 12px 0 8px 0;
  & > li:not(:last-child) {
    display: inline-block;
    position: relative;
    margin-right: 24px;
    ::after {
      position: absolute;
      content: "|";
      font-size: 20px;
      margin: 0 8px;
    }
  }

  @media (min-width: ${Breakpoints.lg}) {
    flex-shrink: 0;
    margin-left: 32px;
    & > li:not(:last-child) {
      display: flex;
      align-items: center;
      ::after {
        display: none;
      }
    }

    & > li {
      display: flex;
      align-items: center;
    }
  }
`

export const JobIcon = styled.img`
  display: none;
  @media (min-width: ${Breakpoints.lg}) {
    display: inline;
    margin-right: 8px;
  }
`

export const LowerTitle = styled.h3`
  ${T.sm.h1.semiBold}
  text-align: center;
  grid-column: 1 / -1;
  margin-top: 64px;
  @media (min-width: ${Breakpoints.md}) {
    ${T.md.h1.regular}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h1.regular}
    margin-top: 96px;
  }
`

export const LowerText = styled.p`
  text-align: center;
  ${T.sm.body.regular}
  grid-column: 1 / -1;
  margin-top: 16px;

  & > br {
    display: none;
  }

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.body.regular}
    margin-top: 24px;
    & > br {
      display: initial;
    }
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.body.regular}
  }
`

export const EmailLink = styled(Link)`
  &,
  :visited,
  :link,
  :active {
    color: var(--burnt-orange);
    text-decoration: none;
  }
`
